{
  "global": {
    "account": "Account | Accounts",
    "action": "Action | Actions",
    "activity": "Activity | Activities",
    "add_object": "Add {object}",
    "administration": "Administration",
    "address": "Address | Addresses",
    "anyone": "Anyone",
    "api": "API",
    "assigned_to": "Assigned to",
    "attach_subject": "Attach {subject}",
    "author": "Author | Authors",
    "automatically_refreshing": "Page refreshing automatically",
    "by": "By",
    "cancel": "Cancel",
    "city": "City",
    "click_to_delete": "Click to delete",
    "click_to_edit": "Click to edit",
    "click_to_view": "Click to view",
    "close": "Close",
    "closed": "Closed",
    "closed_on": "Closed on",
    "company": "Company | Companies",
    "confirm_message": "Are you sure?",
    "contact": "Contact | Contacts",
    "continue": "Continue",
    "count": "Count",
    "create": "Create",
    "create_continue": "Create and continue",
    "create_object": "Create {object}",
    "created_at": "Created at",
    "created_by": "Created by",
    "dashboard": "Dashboard | Dashboards",
    "date": "Date | Dates",
    "default": "Default",
    "delete": "Delete",
    "deleted": "Deleted",
    "description": "Description",
    "details_show": "Show details",
    "difference": "Difference",
    "download": "Download",
    "edit": "Edit",
    "edit_subject": "Edit {subject}",
    "email": "Email | Emails",
    "enter": "Enter",
    "enter_subject": "Enter {subject}",
    "error_generic": "Something went wrong. Please try again later",
    "example": "Example",
    "exclude": "Exclude",
    "export": "Export",
    "file": "File | Files",
    "filename": "Filename | Filenames",
    "from": "From",
    "goto_subject": "Go to {subject}",
    "health": "Health",
    "id": "Id | Ids",
    "latitude": "Latitude",
    "list": "List | Lists",
    "loading": "Loading",
    "location": "Location | Locations",
    "log_out": "Log out",
    "longitude": "Longitude",
    "management": "Management",
    "map": "Map | Maps",
    "me": "Me",
    "metric": "Metric | Metrics",
    "name": "Name",
    "name_first": "First name",
    "name_last": "Last name",
    "no": "No",
    "note": "Note | Notes",
    "notification": "Notification | Notifications",
    "ok": "Ok",
    "open": "Open",
    "open_new_window": "Open in new window",
    "operation": "Operation | Operations",
    "option": "Option | Options",
    "other": "Other | Others",
    "overview": "Overview",
    "owner": "Owner | Owners",
    "password": "Password | Passwords",
    "period": "Period | Periods",
    "phone_number": "Phone number",
    "postal_code": "Postal code",
    "ratio": "Ratio",
    "ratio_difference": "Ratio difference",
    "report": "Report | Reports",
    "reset": "Reset",
    "result": "Result",
    "retired": "Retired",
    "save": "Save",
    "save_continue": "Save and continue",
    "select": "Select",
    "select_a_date": "Select a date",
    "select_an_option": "Select an option",
    "separator": "Separator | Separators",
    "show_all": "Show all",
    "setting": "Setting | Settings",
    "shade": "Shade",
    "skip": "Skip",
    "status": "Status | Statuses",
    "street": "Street | Streets",
    "house_number": "House number",
    "summary": "Summary",
    "support": "Support",
    "test": "Test | Tests",
    "title": "Title",
    "to": "To",
    "tonnes": "Tonnes",
    "type": "Type",
    "unknown": "Unknown",
    "user": "User | Users",
    "value": "Value | Values",
    "yes": "Yes"
  },
  "glossary": {
    "angle": "Tilt",
    "angle_in_degrees": "Tilt in degrees",
    "attached_companies": "Attached companies",
    "cents_per_kwh": "Cents per kWh",
    "current_period": "Current period",
    "custom_fields": "Custom fields",
    "driver": "Driver | Drivers",
    "driver_account": "Driver account | Driver accounts",
    "energy": "Energy",
    "energy_expected": "Expected energy",
    "energy_generated": "Generated energy",
    "energy_lacking": "Lacking energy",
    "found_on": "Found on",
    "issue": "Issue | Issues",
    "long_term": "Long\u00a0Term",
    "ltpm": "Long Term Performance Monitoring",
    "meter": "Meter | Meters",
    "monitored_since": "Monitored since",
    "monitoring": "Monitoring",
    "monitoring_activate": "Activate monitoring",
    "operational_since": "Operational since",
    "orientation": "Orientation",
    "orientation_in_degrees": "Orientation in degrees",
    "panel": "Panel | Panels",
    "peak_total": "Total peak",
    "peak_watt": "Watt peak",
    "performance": "Performance | Performances",
    "performance_monitoring": "Performance Monitoring",
    "performance_ratio": "Performance Ratio | Performance Ratios",
    "performance_ratio_7d": "7 Day Performance Ratio",
    "performance_ratio_30d": "30 Day Performance Ratio",
    "performance_ratio_daily": "Daily Performance Ratio | Daily Performance Ratios",
    "plant": "Plant | Plants",
    "plant_code": "Plant code",
    "plant_name": "Plant name",
    "resolved_on": "Resolved on",
    "retired_on": "Retired on",
    "saved_co2": "CO2 Saved",
    "snoozed_until": "Snoozed until",
    "tag": "Tag | Tags",
    "ticket": "Ticket | Tickets",
    "yield_insight": "Yield Insight | Yield Insights"
  },
  "temporary": {
    "message_panel_groups_need_update": "There are {count} plants that have a mixed orientation but only one panel group. To view these plants, go to 'Plants' and set the Mixed orientation filter to 'Mixed' and the Panel groups filter to 'No'."
  },
  "investigations": {
    "drawer_title": "Investigations ({count})",
    "help_title": "Investigations",
    "help_description": "We tried to find out what is going on with this plant. Below you can read more about our recommendations. This feature is still in development.",
    "found_on": "Found {date}",
    "updated_on": "Last updated {date}",
    "steps_toggle": "Show checks",
    "activity_toggle": "Activity since found ({count})",
    "issues_toggle": "Involved issues ({count})",
    "actions": {
      "helpful": "Helpful?",
      "thumbs_up": "Yes, this was helpful",
      "thumbs_down": "No, this was not helpful",
      "snooze": "Hide for 7 days",
      "snooze_title": "Hide this investigation for 7 days. Useful when you are already working on a fix.",
      "acknowledge": "Seen & handled",
      "acknowledge_title": "Mark as seen. The investigation will be temporarily hidden while the system processes your efforts."
    }
  },
  "features": {
    "activity": {
      "not_found": "No activity found | No activities found"
    },
    "tips": {
      "search_everywhere": "Use Search Everywhere to search for plants form any page",
      "filter_preset": "Save often used filters as a filter preset",
      "add_column": "View more plant properties using the button Add Column",
      "locale_switch": "You can switch languages by clicking on your avatar in the top right corner",
      "whats_new": "Want to stay tuned for updates? Visit the What's new page from the menu",
      "sundata_support": "You can request support on a ticket by assigning Sundata Support",
      "map_filter": "Filtering also works on the map. E.g. when searching for high voltage issues",
      "notes_files": "Save plant specific information on the notes and files tab",
      "aerial_photo": "Navigate to the single plant location tab to view a recent aerial photo",
      "diagnostics": "Not sure what is wrong with a meter? Try meter diagnostics on the meter tab!"
    },
    "account": {
      "settings": "Account settings",
      "settings_for": "Settings for {user}",
      "setting_email": "E-mail setting",
      "daily_status": "Daily status e-mail",
      "daily_status_description": "Status e-mails will notify you of status changes on your plants.",
      "daily_status_receive": "Receive daily status e-mails",
      "unsubscribed_header": "E-mails disabled",
      "unsubscribed_disabled": "E-mails to the address {address} have been automatically disabled. You are not receiving e-mail at this moment.",
      "unsubscribed_stop_when": "We stop sending emails when",
      "unsubscribed_bounced": "Notice that e-mails hard-bounce",
      "unsubscribed_spam": "You've made a spam complaint on a status-email",
      "unsubscribed_other": "You've unsubscribed from our e-mails trough another way than your profile",
      "unsubscribed_support": "Contact our support team to resolve this issue."
    },
    "address_form": {
      "not_found": "Postal code + house number not found",
      "not_found_description": "We were unable to find an address for the provided postal code and house number. This could indicate that these details are incorrect. When you’re sure the combination is correct you can add further details manually.",
      "invalid_postal_code": "The postal code is invalid. Please enter a valid postal code",
      "lat_lon_tool_info": "A nice tool to manually locate the latitude and longitude for any location is the {website_name}",
      "lat_lon_tool_name": "GPS coordinates website",
      "already_exists": "Address already exists. Are you sure you want to continue?"
    },
    "credentials": {
      "credentials": "Credentials",
      "credential_values": "Credentials values",
      "credential_composition": "Credential composition",
      "credential_composition_explanation": "There is more than one way of 'composing' credentials for this account.",
      "feedback_validating": "Validating credentials",
      "feedback_already_exists": "Meter already exists, please enter the unique identifier of the meter.",
      "feedback_invalid": "The meter entered did not validate as a valid meter. Please check the entered data.",
      "feedback_valid": "Credentials are valid"
    },
    "create_meter": {
      "add_to": "Add meter to",
      "low_peak_watt": "This value seems low, is it correct?",
      "operational_since_tooltip": "Can be up to a year in the past."
    },
    "create_plant": {
      "feedback_enter_name": "Please enter a name",
      "feedback_monitored_since": "Supply a monitored since date",
      "tags_companies": "Tags and companies"
    },
    "health": {
      "sub_title": "Long term performance monitoring- and Issues grouped by the date that they were found on"
    },
    "check_panel_group_roof": {
      "check_roof_surface": "Check roof surface",
      "values_filled_in": "The orientation and tilt of the chosen roof surface are filled in for panel group {name}. Check the values and save."
    },
    "update_meter": {
      "edit_meter": "Edit meter",
      "no_permission_message": "You don't have permissions to edit this meter since your company {company} is not the owner of the plant.",
      "success_message": "Meter successfully updated! The dialog will close in 2 seconds..."
    },
    "retire_meter": {
      "retire_meter": "Retire meter",
      "retirement_date": "Retirement date",
      "alert_message": "Retiring excludes a meter from the determination of the status, but it keeps the generated energy. It can't be undone.",
      "success_message": "Meter was retired! The dialog will close in 2 seconds..."
    },
    "linked_fields_overview": {
      "owned": "Owned fields",
      "visible": "Visible fields",
      "attached": "Attached fields",
      "belongs_to": "This field belongs to {company}",
      "viewed_by": "These fields can be viewed by {company}",
      "removed": "Removed {field} from {company}",
      "removed_fail": "Failed to remove field from company",
      "added": "Added {field} to {company}",
      "added_fail": "Failed to add field to company",
      "help_intro": "Custom fields let you store your own information on plants, such as a project number, installer or contract type.",
      "help_columns": "Show them as columns in the plants overview",
      "help_filters": "Filter and search plants on their values",
      "help_plants": "Fill them in when you create or edit a plant",
      "help_request": "Your company does not have custom fields yet. Contact us via chat support to set them up."
    },
    "child_company_tags": {
      "attached": "Attached tags",
      "viewed_by": "These tags can be viewed by {company}",
      "no_tags": "{company} does not own any tags",
      "removed": "Removed {tag} from {company}",
      "removed_fail": "Failed to remove tag from company",
      "added": "Added {tag} to {company}",
      "added_fail": "Failed to add tag to company"
    },
    "create_note": {
      "button": "Create note",
      "checkbox_title": "Makes the note only visible to people within {company}",
      "placeholder": "Leave a note regarding this plant",
      "private": "Private"
    },
    "note_list": {
      "delete_note_confirm": "Are you sure you want to delete this note?",
      "only_visible_to": "Only visible to {company}"
    },
    "custom_field": {
      "not_empty": "Can't save empty value"
    },
    "dashboard_issues": {
      "chart_description": "We've updated your dashboard to help you focus more on the plants that need attention vs plants that are performing fine.",
      "chart_sub_title": "Issues found- and resolved over the selected period",
      "chart_title": "Issue Chart",
      "sub_title": "Counts for unresolved issues",
      "title": "Counts per type"
    },
    "dashboard_performance": {
      "sub_title": "An overview of the company's performance during the selected period."
    },
    "export_tab": {
      "help_description": "Use ';' for computers set to Dutch"
    },
    "help_icon": {
      "go_to_support": "Go to support article"
    },
    "single_plant": {
      "tags_edit": "Edit tags",
      "companies_edit": "Edit companies",
      "custom_fields_edit": "Edit custom fields",
      "nr_active_meters": "Nr of active meters",
      "analyse_period": "Analyse period",
      "shade_past_14_days": "{days_nr} / 14 days"
    },
    "single_plant_performance": {
      "sub_title": "Performance graphs in multiple dimensions",
      "weekly_lifetime": {
        "sub_title": "Performance ratio per week over the lifetime of the plant"
      },
      "hour_pr": {
        "sub_title": "Performance ratio per hour"
      },
      "chart_warning_expected_incomplete": "Last {{ nr_periods }} period(s) aren't shown because the expected energy has not completed yet."
    },
    "single_plant_issues": {
      "show_resolved": "Show resolved",
      "notifications_over_time": "Notifications over time",
      "status_type_info": "Status type info",
      "row_types": {
        "meter-statuses": "Findings per day",
        "meter-issues": "Issues open day"
      }
    },
    "single_plant_long_term": {
      "sub_title": "Monitoring the performance over a periods of a year",
      "tooltip_description": "When a newWhen a new plant has been created you probably made a promise about the yearly yield it will generate. Long Term Performance Monitoring helps you to monitor the promise you made. plant has been created you probably made a promise about the yearly yield it will generate. Long Term Performance Monitoring helps you to monitor the promise you made.",
      "message_no_ltpm": "This plant doesn't have any long term monitoring yet. This could be because this plant is only being monitored since recently ({date}). It usually takes about a week before long-term-monitoring starts. Please come back later"
    },
    "single_plant_location": {
      "button_3dbag": "Roof surface tilt check"
    },
    "single_plant_meters": {
      "sub_title": "Meters connected to this plant.",
      "retired_tooltip": "This excludes a meter from the determination of the status, but it keeps the generated energy."
    },
    "single_plant_contacts": {
      "sub_title": "Residents or other persons attached to this plant.",
      "plant_contact": "Plant contact"
    },
    "search_cart": {
      "advanced_search": "Advanced search",
      "search": "Search everywhere",
      "type_to_start": "Start typing to search everywhere.."
    },
    "panel_config_form": {
      "help_message": "Not sure about the orientation and angle of the panels? {link}",
      "help_message_link": "Click here to get some help"
    },
    "panel_config_helper": {
      "title": "Select roof surface for panel settings",
      "title_for_panel_group": "Select roof surface for panel group '{name}'",
      "loading": "Loading roof surfaces",
      "click_to_select": "Click a roof surface to select it",
      "current_settings": "Current settings",
      "selected_settings": "Selected roof surface",
      "select_and_edit": "Select and edit meter",
      "table": {
        "title": "Roof surfaces",
        "color": "Roof color",
        "area": "Area in m2"
      }
    },
    "plants": {
      "sub_title": "Search for specific plants",
      "empty": "No plants found!"
    },
    "plant_issues": {
      "tooltip_occurrence": "occurrences of",
      "tooltip_with_snoozed": "with at least one snoozed until"
    },
    "plant_report": {
      "button_label": "Download Report",
      "title": "Plant Report",
      "please_hold": "It may take a moment to create the report. Especially when multiple meters are involved.",
      "open_window": "Open in new window"
    },
    "location": {
      "button_pdok_aerial": "Aerial photo",
      "button_pdok_height": "Height map"
    },
    "plant_issue_filter": {
      "dont_show": "Don't show issues with the following new issues",
      "show": "Only show issues that have the following new issues"
    },
    "plant_tickets_filter": {
      "has_ticket": "Has a ticket",
      "no_ticket": "Has no tickets",
      "open_ticket": "Has an open ticket",
      "no_open_ticket": "Has no open tickets"
    },
    "plant_custom_field_filter": {
      "no_fields_found": "No custom fields found!"
    },
    "issues": {
      "sub_title": "Plants that have issues",
      "help_description": "Indicating issues with the plant",
      "found_on_tooltip": "Date when the issue was found",
      "open": "Open issues",
      "no_open": "There are no open issues",
      "snoozed": {
        "snooze_issue": "Snooze issue",
        "snooze_for": "Snooze for",
        "snoozed_success": "Issue successfully snoozed! Dialog will close in 2 seconds...",
        "unsnooze_issue_confirm": "Are you sure you want to unsnooze this issue?"
      }
    },
    "date_range_picker": {
      "last_7d": "Last 7 days",
      "last_6w": "Last 6 weeks",
      "last_12m": "Last 12 months"
    },
    "period_picker": {
      "hours": "In hours",
      "days": "In days",
      "weeks": "In weeks",
      "months": "In months"
    },
    "meter_picker": {
      "all_meters": "All meters"
    },
    "main_menu": {
      "all_tickets": "All tickets",
      "single_ticket": "Single ticket",
      "all_plants": "All plants",
      "single_plant": "Single plant",
      "password_reset": "Reset password",
      "password_forgot": "Forgot password",
      "sign_in": "Sign in",
      "whats_new": "What's new"
    },
    "main_menu_driver_status": {
      "unavailable": "Driver status unavailable",
      "degraded": "Degraded drivers",
      "ok": "All drivers ok"
    },
    "file_list": {
      "view_in_new_window": "View in new window",
      "delete_file_confirm": "Are you sure you want to delete this file?"
    },
    "filtering": {
      "groups": {
        "plant": "Plant",
        "address": "Address",
        "status": "Status",
        "tickets": "Tickets",
        "meter": "Meter"
      },
      "names": {
        "query": "Search",
        "assigned_to": "Ticket assignee",
        "ticket_status": "Ticket status",
        "template": "Template",
        "issues": "Issues",
        "issues_new": "New issues",
        "issues_existing": "Existing issues",
        "snoozed_issue": "Snoozed issues",
        "resolved_issue": "Resolved issues",
        "mixed_orientation": "Mixed orientation",
        "multiple_panel_groups_filter": "Panel groups",
        "has_meter": "Has Meter",
        "non_mon": "Light plants",
        "tickets": "Tickets"
      },
      "labels": {
        "query": "Search for plants",
        "assigned_to": "Assigned to",
        "ticket_status": "Ticket status",
        "template_ids": "Filter by ticket-template",
        "tag_ids": "Filter by tag",
        "postal_code": "Search for postal code",
        "street": "Search for street",
        "street_number": "Search for house number",
        "city": "City",
        "driver_account_ids": "Filter by driver",
        "child_company_ids": "Filter by attached company",
        "peak_in_watt": "Filter by peak in Watt",
        "operational_since": "Filter by operational date",
        "monitored_since": "Filter by monitored since date",
        "monitored": "Filter by Light plants",
        "issues": "Issues",
        "snoozed_issue": "Include snoozed issues",
        "resolved_issue": "Include resolved issues",
        "ltpm": "Performance monitoring:",
        "found_on": "Found on",
        "mixed_orientation": "Filter on Mixed Panel Orientation",
        "multiple_panel_groups": "Has multiple panel groups",
        "has_meter": "Has Meter?",
        "custom_fields": "Filter on Custom Fields",
        "plant_code": "Filter on Plant Code",
        "tickets": "Tickets",
        "ticket_child_company_ids": "Filter by attached company",
        "new_issues": "New issues",
        "yield_score_7d": "Filter by 7 day performance ratio",
        "yield_score_30d": "Filter by 30 day performance ratio",
        "remove_filter": "Remove filter",
        "filter_preset": "Filter preset | Filter presets",
        "copy_to_search_cart": "Copy to search cart",
        "credential_values": "Filter on Credentials"
      },
      "explanations": {
        "issues": "Filter by the issues that a plant has.",
        "issues_new": "Filters on the 'New Issues'. It ignores any existing issues.",
        "monitored_since": "Day since when a plant became monitored",
        "operational_since": "Day since when a plant meter is operational",
        "long_term": "Filter on the performance of the current period."
      },
      "presets": {
        "empty": "Start by setting- and saving some filters.",
        "store_title": "Save filters",
        "store": "Save filters",
        "prompt_alias": "Please give a name for this preset.",
        "management_title": "Manage filter presets",
        "level_company": "Company Presets",
        "level_user": "Personal Presets"
      },
      "glossary": {
        "mixed": "Mixed",
        "uniform": "Uniform"
      }
    },
    "historical_summary": {
      "over_period": "Summary over period",
      "checks_for_meter": "Checks for meter id {meter_id}"
    },
    "performance_statistics": {
      "energy_expected_total_period": "Total expected energy in period",
      "energy_generated_total_period": "Total generated energy in period",
      "forecast_ratio_about": "About this Forecast Ratio",
      "forecast_ratio_over_period": "Forecast Ratio over period",
      "saved_co2_total_period": "Total CO2 saved in period"
    },
    "performance_ratio": {
      "description": "The ratio between the generated- and expected yield of a plant over the past {nr_days} days"
    },
    "long_term": {
      "period_progress": "Period progress",
      "progress": "Progress",
      "promised_till_now": "Promised till now",
      "promised": "Promised",
      "last_14d": "Over the last 14 days",
      "sub_title": "An overview of the long-term performance of your plants over multiple years. Each year-period is displayed as a single contract-icon. You are in control over the yield you expect in a certain period for a plant.",
      "summary": {
        "early": "It's <strong>too early</strong> to tell for this period.",
        "ahead": "The performance in the current period is <strong>ahead</strong> of schedule.",
        "far_ahead": "The performance in the current period is <strong>greatly ahead</strong> of schedule.",
        "behind": "The performance is <strong>behind</strong> but it might catch up.",
        "severely_behind": "The performance is <strong>severely behind</strong> and is unlikely to catch up.",
        "not_configured": "This period has not yet been configured. You can do so below, or it will automatically be configured during the next night.",
        "unknown": "The application received an unknown summary flag. Please let us know and we will fix it. Thanks!"
      },
      "insight": {
        "reason": "The main reason for lacking yield in this period is '{reason}'."
      },
      "explainer": {
        "period_title": "Period {start} to {end}",
        "setting_description": "The long term performance monitoring for this plant starts on the {date} and is set to {setting}.",
        "setting_updating": "This period is being updated. Please refresh this page after a minute or so.",
        "ongoing_irradiance": "In this period {irradiance_percentage} of the solar radiation has occurred. ",
        "ongoing_early": "This means that it is {term} to make strong conclusions. It might help to look at previous periods if those exist.",
        "ongoing_delivered_till_now": "Thus far {delivered} has been realized.",
        "ongoing_behind": "This means that the plant is {missing} behind. To make up for this the plant needs to have a performance of at least {needed} during the rest of the period",
        "ongoing_ahead": "This means that the plant is {term} by {ahead}.",
        "ended_total": "This period has ended. In total {delivered} has been realized. The weather-corrected threshold is {promised}.",
        "ended_result": "This means that the plant produced {result} what was configured.",
        "too_early": "too early",
        "ahead": "ahead",
        "within_05": "within 0.5%",
        "less": "less than",
        "more": "more than",
        "change_settings": "Change settings"
      },
      "gap_fills": {
        "button_add_view": "Fill yield gap and view gap fills",
        "create_error": "Gap fill could not be created.",
        "create_success": "Gap fill created! The period will now be updated. Come back later to see the change.",
        "delete_confirm": "Are you sure you want to delete this gap fill?",
        "dialog_period_ahead": "The period is ahead with {yield_ahead}. A gap fill is not necessary.",
        "dialog_period_yield": "{yield_actual} has been produced in this period. {yield_filled} of that has been gap filled.",
        "dialog_period_missing": "{yield_missing} is still missing.",
        "existing_item": "On {created_at}, {yield} has been filled with the reason: {reason}",
        "existing_title": "Existing gap fills",
        "gap_fill": "Gap fill | Gap fills",
        "gap_fill_including": ", including gap fills,",
        "gap_fills_created_wh": "A total of {yield} has been filled for this period.",
        "gap_fills_none_created": "No gap fills have been created.",
        "intro": "Gap fills are used to accept known gaps in yield. This keeps the long term monitoring relevant.",
        "modal_title": "Long term gap fills",
        "period_ended": "Please note, this period has ended!",
        "reason": "Reason",
        "reason_none": "No reason given"
      },
      "columns": {
        "status_since": "Status since",
        "status_since_tooltip": "Shows how far back the icon color of the current period last changed.",
        "current_promise_tooltip": "Indicating the performance during the current period. Click on one of the icons to see more details.",
        "promise_start_on": "Started on {date}",
        "previous_periods": "Previous periods",
        "current_difference": "Current period difference"
      },
      "filter_options": {
        "only_current": "Only current period",
        "only_previous": "Only previous periods",
        "any": "Any period"
      },
      "step": {
        "title": "Long Term Performance Setting",
        "description": "We've found {meter_count} active meters with a combined peakWatt of {peak_watt_sum} Wp.",
        "conservative_title": "Conservative",
        "conservative_description": "There is a high probability that this plant produces more energy than this. You may choose this option when the conditions of the plant are suboptimal, for example when shade is expected.",
        "optimistic_title": "Optimistic",
        "optimistic_description": "This is our prognosis of the produced energy over a year on average. That is under optimal conditions, so without shade. You may choose this is you want to stay on top of everything that is going on with this plant. We recommend that you do not go higher than this value.",
        "custom_title": "Custom",
        "custom_description": "Use this option when you have a specified amount of energy that should be used. For instance when there is a contract or other promise in place for this plant.",
        "msg_for_light": "Light plants don't need a setting for Long Term Monitoring. This can be configured later when a plant is upgraded to Sundata Pro.",
        "current_title": "Current",
        "current_description": "This is the current setting for this period. You can choose to keep this setting or change it to one of the other options."
      }
    },
    "sign_in": {
      "sign_in": "Sign in",
      "login": "Log in",
      "credentials_incorrect": "Incorrect credentials",
      "password_forgot": "Forgot password"
    },
    "support": {
      "here_to_help": "We are here to help",
      "to_knowledge_base": "Open our knowledge base",
      "chat_support": "Open chat support"
    },
    "tab_export": {
      "filename_allowed_characters": "Only letters, numbers and underscores are allowed",
      "issues": "Export issues to a spreadsheet",
      "plants_meters": "Export plants or meters to a spreadsheet",
      "export_as": "Export as",
      "include_credentials": "Include credentials",
      "report_loading": "Report is being generated",
      "report_requested": "Report is being requested",
      "report_wait_for": "It will become available here: {page}",
      "reports_page": "Reports page",
      "progress_tooltip": "{completed} of {total} rows completed",
      "status": {
        "failed": "Failed"
      }
    },
    "tickets": {
      "ticket": "Ticket | Tickets",
      "assign_me": "Assign to me",
      "open_tickets": "Open tickets",
      "create_ticket": "Create ticket",
      "create_ticket_for": "Create ticket for {plant}",
      "no_open": "There are no open tickets",
      "include_closed": "Include closed tickets",
      "support_assigned_title": "Direct contact with Sundata Support",
      "support_assigned_description": "A support employee will answer your ticket as soon as possible. Normally this takes around 1 business day.",
      "support_assigned_languages": "Support is available in both Dutch and English.",
      "support_assigned_link": "For more information, see {link}",
      "this_support_article": "this support article",
      "unassigned": "Unassigned",
      "attach_child_company": "Attach child company",
      "company_assign_confirm": "Are you sure you want to attach {company} to this ticket?",
      "company_detach_confirm": "Are you sure you want to remove {company} from this ticket?",
      "template_description": "Template description",
      "template_name": "Template name",
      "template_title": "Template title",
      "reopen_ticket": "Re-open ticket",
      "change_template": "Change template",
      "close_ticket": "Close ticket",
      "go_to_plant": "Go to plant",
      "assignees": "Assignees",
      "assign_confirm": "Are you sure you want to assign {name}?",
      "assign_users": "Assign users",
      "no_assignees": "No assignees",
      "un_assign_confirm": "Are you sure you want to un-assign {name}?",
      "comment_not_empty": "A comment cannot be empty",
      "details_hide": "Hide details",
      "action_assigned": "was assigned {date}",
      "action_unassigned": "was un-assigned {date}"
    },
    "panel_group": {
      "panel_group": "Panel group | Panel groups"
    },
    "password": {
      "new": "New password",
      "change": "Change password",
      "confirm": "Confirm",
      "no_match": "Passwords do not match",
      "rule_number": "Password must contain a number",
      "rule_symbol": "Password must contain a symbol",
      "rule_char": "Password must contain at least 8 characters"
    },
    "yield_insights": {
      "not_available": "Yield insights currently not available",
      "tooltip": "Yield Insights are determined by comparing the generated- and expected energy for each day over the last 60 days. The days that are lacking energy are grouped by reason and shown here."
    },
    "yield_insights_chart": {
      "title": "Possible reasons for lacking energy\nover the last 60 days"
    },
    "go_to_portal_item": {
      "go_to": "Go to Portal",
      "not_supported": "Portal not supported"
    },
    "meter_test_item": {
      "run": "Run {test}",
      "production": "production test",
      "connection": "connection test"
    },
    "cast4all_check_dialog": {
      "run_for": "Run {test} for {name}",
      "run": "Press the button to run the test",
      "requesting": "The test is being requested. Please wait.",
      "requested": "The test has been requested. This may take a minute or more.",
      "success_production": "The test has completed successfully. Measured average voltage: {voltage}V",
      "success_connection": "The test has completed successfully with status; {status}.",
      "failed": "The test has completed with status; {status} and result; {result}."
    },
    "meter_diagnostics": {
      "run": "Run diagnostics",
      "run_for": "Run diagnostics for",
      "meter_existence": "Meter existence",
      "meter_existence_validated": "We were able to validate the existence of the meter.",
      "meter_existence_not_validated": "We could not validate the existence of the meter. Are you sure the credentials are correct?",
      "latest_yield": "Latest yield",
      "total_recent_yield": "Total recent yield",
      "alerts": "Alerts",
      "no_alerts_found": "No alerts found",
      "level": "Level"
    },
    "changelog": {
      "idea_invitation": "Have an idea or suggestion? Please let us know using Intercom or click on this message."
    },
    "reports": {
      "page_description": "Here we prepare your downloadable reports.",
      "report_list_plant": "Plant list report",
      "report_list_meter": "Meter list report",
      "report_list_issue": "Issues list report"
    },
    "issue_values": {
      "yield_promise_status": {
        "tooltip": "Long Term Performance Monitoring",
        "extended_tooltip": "Plant lacking long term performance"
      },
      "shade": {
        "tooltip": "Shade during the day",
        "extended_tooltip": "Shade during the day"
      },
      "new": {
        "tooltip": "Newly created plant",
        "extended_tooltip": "Newly created plant"
      },
      "ticket": {
        "tooltip": "Ticket",
        "extended_tooltip": "Ticket"
      },
      "misc": {
        "tooltip": "Miscellaneous Issue",
        "extended_tooltip": "Miscellaneous Issue"
      },
      "power_spike": {
        "tooltip": "Power Spike",
        "extended_tooltip": "A power spike was observed"
      }
    },
    "metric_values": {
      "new": {
        "tooltip": "Recently created",
        "extended_tooltip": "Plant that became operational in the last 30 days"
      },
      "total": {
        "tooltip": "Total plants",
        "extended_tooltip": "Total amount of plants created"
      },
      "open_tickets": {
        "tooltip": "Open Tickets",
        "extended_tooltip": "All currently open tickets"
      },
      "panel_group_update_needed": {
        "tooltip": "Panel groups to update",
        "extended_tooltip": "Plants needing a panel group update"
      }
    }
  },
  "primevue": {
    "accept": "Yes",
    "addRule": "Add Rule",
    "am": "AM",
    "apply": "Apply",
    "cancel": "Cancel",
    "choose": "Choose",
    "chooseDate": "Choose Date",
    "chooseMonth": "Choose Month",
    "chooseYear": "Choose Year",
    "clear": "Clear",
    "column": "Column",
    "completed": "Completed",
    "contains": "Contains",
    "custom": "Custom",
    "dateAfter": "Date is after",
    "dateBefore": "Date is before",
    "dateFormat": "mm/dd/yy",
    "dateIs": "Date is",
    "dateIsNot": "Date is not",
    "dayNames": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "dayNamesMin": ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    "dayNamesShort": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    "emptyFilterMessage": "No results found",
    "emptyMessage": "No available options",
    "emptySearchMessage": "No results found",
    "emptySelectionMessage": "No selected item",
    "endsWith": "Ends with",
    "equals": "Equals",
    "fileSizeTypes": ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    "filter": "Filter",
    "firstDayOfWeek": 0,
    "gt": "Greater than",
    "gte": "Greater than or equal to",
    "lt": "Less than",
    "lte": "Less than or equal to",
    "matchAll": "Match All",
    "matchAny": "Match Any",
    "medium": "Medium",
    "monthNames": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "monthNamesShort": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "nextDecade": "Next Decade",
    "nextHour": "Next Hour",
    "nextMinute": "Next Minute",
    "nextMonth": "Next Month",
    "nextSecond": "Next Second",
    "nextYear": "Next Year",
    "noFilter": "No Filter",
    "notContains": "Not contains",
    "notEquals": "Not equals",
    "now": "Now",
    "passwordPrompt": "Enter a password",
    "pending": "Pending",
    "pm": "PM",
    "prevDecade": "Previous Decade",
    "prevHour": "Previous Hour",
    "prevMinute": "Previous Minute",
    "prevMonth": "Previous Month",
    "prevSecond": "Previous Second",
    "prevYear": "Previous Year",
    "reject": "No",
    "removeRule": "Remove Rule",
    "searchMessage": "{0} results are available",
    "selectionMessage": "{0} items selected",
    "showMonthAfterYear": false,
    "startsWith": "Starts with",
    "strong": "Strong",
    "today": "Today",
    "upload": "Upload",
    "weak": "Weak",
    "weekHeader": "Wk",
    "aria": {
      "cancelEdit": "Cancel Edit",
      "close": "Close",
      "collapseLabel": "Collapse",
      "collapseRow": "Row Collapsed",
      "editRow": "Edit Row",
      "expandLabel": "Expand",
      "expandRow": "Row Expanded",
      "falseLabel": "False",
      "filterConstraint": "Filter Constraint",
      "filterOperator": "Filter Operator",
      "firstPageLabel": "First Page",
      "gridView": "Grid View",
      "hideFilterMenu": "Hide Filter Menu",
      "jumpToPageDropdownLabel": "Jump to Page Dropdown",
      "jumpToPageInputLabel": "Jump to Page Input",
      "lastPageLabel": "Last Page",
      "listView": "List View",
      "moveAllToSource": "Move All to Source",
      "moveAllToTarget": "Move All to Target",
      "moveBottom": "Move Bottom",
      "moveDown": "Move Down",
      "moveToSource": "Move to Source",
      "moveToTarget": "Move to Target",
      "moveTop": "Move Top",
      "moveUp": "Move Up",
      "navigation": "Navigation",
      "next": "Next",
      "nextPageLabel": "Next Page",
      "nullLabel": "Not Selected",
      "otpLabel": "Please enter one time password character {0}",
      "pageLabel": "Page {page}",
      "passwordHide": "Hide Password",
      "passwordShow": "Show Password",
      "previous": "Previous",
      "previousPageLabel": "Previous Page",
      "rotateLeft": "Rotate Left",
      "rotateRight": "Rotate Right",
      "rowsPerPageLabel": "Rows per page",
      "saveEdit": "Save Edit",
      "scrollTop": "Scroll Top",
      "selectAll": "All items selected",
      "selectLabel": "Select",
      "selectRow": "Row Selected",
      "showFilterMenu": "Show Filter Menu",
      "slide": "Slide",
      "slideNumber": "{slideNumber}",
      "star": "1 star",
      "stars": "{star} stars",
      "trueLabel": "True",
      "unselectAll": "All items unselected",
      "unselectLabel": "Unselect",
      "unselectRow": "Row Unselected",
      "zoomImage": "Zoom Image",
      "zoomIn": "Zoom In",
      "zoomOut": "Zoom Out"
    }
  }
}
